import React, { memo } from "react";
import { View, Text } from "react-native";
import { CreateResponsiveStyle } from "rn-responsive-styles";
import LiveStream from "../../../../../Components/live-streaming-common-components/LiveStream";
import { AppFontStyle } from "../../../../../styles/AppFontStyle";
import { AppColors } from "../../../../../utility/AppColors";

interface MatchPreviewComponentProps {
  streamStatus: "pending" | "live" | "paused" | "completed";
  platform: "youtube" | "twitch";
  streamId?: string;
}

const MatchPreviewComponent = memo<MatchPreviewComponentProps>(
  ({ streamStatus, platform, streamId }) => {
    const styles = useStyles();

    return (
      <View style={styles.container}>
        {/* Your Screen Preview */}
        <View style={styles.mainPreview}>
          <Text style={[AppFontStyle.BOLD_ANYBODY_12, styles.header]}>
            Your Screen - Audience Preview
          </Text>
          <View style={styles.previewSection}>
            {streamStatus === "live" && streamId ? (
              <LiveStream
                platform={platform}
                streamId={streamId}
                width="100%"
                height="100%"
                style={styles.liveStream}
                preventRedirect={true}
              />
            ) : (
              <View style={styles.statusContainer}>
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_16,
                    { color: AppColors.white },
                  ]}
                >
                  {streamStatus === "pending"
                    ? "Ready to Start"
                    : "Stream Offline"}
                </Text>
              </View>
            )}
          </View>
        </View>

        {/* Opponent Screen Preview */}
        <View style={styles.mainPreview}>
          <Text style={[AppFontStyle.BOLD_ANYBODY_12, styles.header]}>
            Opponent Screen Preview
          </Text>
          <View style={styles.previewSection}>
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white, opacity: 0.5 },
              ]}
            >
              Coming Soon
            </Text>
          </View>
        </View>
      </View>
    );
  }
);

export default MatchPreviewComponent;

const useStyles = CreateResponsiveStyle({
  container: {
    flexDirection: "row",
    height: 300,
    justifyContent: "space-between",
    backgroundColor: AppColors.grayColor_282828,
    borderRadius: 12,
    padding: 12,
    gap: 12,
    width: "100%",
    position: "relative",
    overflow: "hidden",
  },
  mainPreview: {
    flex: 1,
  },
  previewSection: {
    backgroundColor: AppColors.sidebarBorder_374151,
    borderRadius: 8,
    padding: 12,
    alignItems: "center",
    height: "90%",
    justifyContent: "center",
    flex: 1,
    position: "relative",
  },
  header: {
    color: AppColors.white_C3C3C3,
    marginBottom: 8,
  },
  liveStream: {
    borderRadius: 8,
    overflow: "hidden",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
  },
  statusContainer: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
});
